import { render, staticRenderFns } from "./BusinessAccommodationComponent.vue?vue&type=template&id=44f4f830"
import script from "./BusinessAccommodationComponent.vue?vue&type=script&lang=js"
export * from "./BusinessAccommodationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports